import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
const benefits = ['Fundamentos energéticos y bases del Reiki Usui', 'Anatomía energética y sistema de chakras', 'Protocolo completo de sesión profesional', 'Símbolos sagrados y su aplicación avanzada', 'Trabajo emocional y liberación de bloqueos', 'Técnicas de protección y limpieza energética', 'Reiki a distancia y aplicaciones avanzadas', 'Liderazgo, ética profesional y desarrollo de práctica', 'Meditaciones guiadas para profundizar la práctica', 'Cómo estructurar y cobrar por tus servicios'];
export function MasterySection() {
  return <section className="py-24 relative overflow-hidden" data-id="element-232">
      {/* Background with gradient */}
      <div className="absolute inset-0 bg-gradient-to-b from-[#1e1254] to-[#0f0a2e]" data-id="element-233" />

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-234">
        <div className="text-center max-w-4xl mx-auto mb-16" data-id="element-235">
          <motion.h2 className="text-3xl md:text-5xl font-bold mb-6 text-white" initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-236">
            Lo que Dominarás con Esta Formación
          </motion.h2>
          <p className="text-xl text-purple-200 font-light" data-id="element-237">
            Competencias reales para una práctica profesional
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-x-12 gap-y-6 max-w-5xl mx-auto" data-id="element-238">
          {benefits.map((benefit, index) => <motion.div key={index} className="flex items-start space-x-4 p-4 rounded-lg hover:bg-white/5 transition-colors" initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.05
        }} data-id="element-239">
              <div className="flex-shrink-0 mt-1" data-id="element-240">
                <div className="bg-[#d4af37] rounded-full p-1" data-id="element-241">
                  <Check className="w-3 h-3 text-[#0f0a2e] stroke-[3]" data-id="element-242" />
                </div>
              </div>
              <span className="text-lg text-gray-100 font-light" data-id="element-243">
                {benefit}
              </span>
            </motion.div>)}
        </div>

        <motion.div className="mt-16 text-center" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.5
      }} data-id="element-244">
          <a href="#pricing" className="inline-block px-10 py-4 bg-transparent border-2 border-[#d4af37] text-[#d4af37] hover:bg-[#d4af37] hover:text-[#0f0a2e] font-bold rounded-sm transition-all duration-300 text-lg uppercase tracking-wider" data-id="element-245">
            Ver Planes de Acceso
          </a>
        </motion.div>
      </div>
    </section>;
}